<template>
    <div>
        <div class="row">
            <div class="col-md-4 col-sm-4 col-lg-4">
                <div class="container pt-2">
                    <a class="text-primary underline-primary" v-on:click="orderGoBack()"><i class="fas fa-angle-left fa-1x"></i> &nbsp;Go Back</a>
                    <hr />
                    <div class="text-left">
                        <h4 class="py-3 pl-2">Customer Details</h4>
                        <div v-if="orderDetails.customer">
                            <h6 v-if="orderDetails.customer.full_name"> <i class="bi bi-person"></i> {{orderDetails.customer.full_name}}
                                <hr class="my-2" />
                            </h6>
                            <h6 v-if="orderDetails.customer.phone"> <i class="bi bi-phone"></i> {{orderDetails.customer.phone}}
                                <hr class="my-2" />
                            </h6>
                            <h6 v-if="orderDetails.customer.email"> <i class="bi bi-envelope"></i> {{orderDetails.customer.email}}
                                <hr class="my-2" />
                            </h6>
                            <p><i class="bi bi-pin"></i>{{orderDetails.customer.apartment}} {{orderDetails.customer.address_address}} Kenya</p>
                        </div>
                        <div v-else>
                            <h6> <i class="bi bi-person"></i> Default Customer</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8 col-sm-8 col-lg-8">
                <div class="container pt-3">
                    <div class="text-center">
                        <h2>Select Payment Method</h2>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="col-6">
                            <div class="float-left">
                                <h5 class="pt-3">Pay</h5>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="float-right">
                                <h5 v-if="orderDetails.partial" class="pt-3">{{convertCurrencyToLocal(orderDetails.balance)}} </h5>
                                <h5 v-else class="pt-3">{{convertCurrencyToLocal(orderDetails.total_amount)}} </h5>
                                <hr/>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex" v-if="companySettings.has_kds">

                     <a href="/orders" class="btn rounded btn-secondary flex-grow-1 mx-1">Hold Order</a>
                     <a v-b-modal="'create-kitchen-note-modal'" class="btn rounded btn-outline-primary flex-grow-1 mx-1">Send To Kitchen</a>
                         <a v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage orders')" @click="choosePaymentMethodModalShow" class="btn rounded flex-grow-1 btn-primary">Process Payments</a>
                         <a v-else :href='"/print_invoice/" + orderDetails?.id'  class="btn rounded flex-grow-1 btn-primary">Print Customer Receipt</a>
                        <!-- <div class="dropleft">
                            <button class="btn btn-outline-primary rounded dropdown-toggle flex-grow-1 mx-1" type="button" data-toggle="dropdown" aria-expanded="false">
                                More ...
                            </button>
                            <div class="dropdown-menu px-3">
                                  <a @click="choosePaymentMethodModalShow" class="flex-grow-1 dropdown-item border-bottom">Process Payments</a>

                                    <a v-if="userDetails.roles[0].name ==='Admin' || companySettings.allow_employees_delete_orders" v-on:click="discardOrder(orderDetails)" class="dropdown-item text-danger">Cancel Order</a>


                            </div>
                        </div> -->
                    </div>
                    <div class="d-flex" v-else>
                        <a v-if="userDetails.roles[0].name ==='Admin' || companySettings.allow_employees_delete_orders" v-on:click="discardOrder(orderDetails)" class="btn rounded btn-outline-secondary flex-grow-1 ">Cancel Order</a>
                        <a href="/orders" class="btn rounded btn-secondary flex-grow-1 mx-1">Hold Order</a>
                        <a @click="choosePaymentMethodModalShow" class="btn rounded flex-grow-1 btn-primary">Process Payments</a>
                    </div>
                    <p>
                        <small v-if="disabledPaymentGateways > 0" class="text-danger">You can enable payments methods in settings</small>
                    </p>
                    <div class="container d-inline">
                        <table class="table">
                            <thead>
                                <tr>
                                    <td>Item</td>
                                    <td>Qty</td>
                                    <td>Amount</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="orderItem in orderDetails.orders">
                                    <td v-if="orderItem.product_id">{{ orderItem.product.product }}</td>
                                    <td v-else>
                                        {{ orderItem.grouped_inventory.group_title}}
                                        <hr class="m-0" />
                                        <ul class="unstyled">
                                            <li v-if="item.product.can_be_sold" v-for="item in orderItem.grouped_inventory.grouped_items" :key="item.id">{{ item.product.product }} - ({{ item.count }})</li>
                                        </ul>
                                    </td>
                                    <td>{{ orderItem.qty }}</td>
                                    <td v-if="orderItem.product_id && orderItem.is_retail===1">{{ orderItem.product.ppu * orderItem.qty }}</td>
                                    <td v-else-if="orderItem.product_id && orderItem.is_retail ===0">{{ orderItem.product.wholesale_sp * orderItem.qty }}</td>
                                    <td v-else-if="orderItem.is_grouped && orderItem.is_retail ===1">{{ orderItem.grouped_inventory.cost * orderItem.qty }}</td>
                                    <td v-else-if="orderItem.is_grouped && orderItem.is_retail ===0">{{ orderItem.grouped_inventory.wholesale * orderItem.qty }}</td>
                                    <!-- <td v-else>{{ orderItem.product.wholesale_ppu * orderItem.qty }}</td> -->
                                </tr>
                                <tr>
                                    <td>
                                        <h6 class="font-weight-bolder">Sub total</h6>
                                    </td>
                                    <td></td>
                                    <td>
                                        <h6 class="font-weight-bolder">{{convertCurrencyToLocal(orderDetails.total_amount)}}</h6>
                                    </td>
                                </tr>
                                <tr v-if="orderDetails.discount !== null">
                                    <td>
                                        <h6 class="font-weight-bolder">Discount</h6>
                                    </td>
                                    <td></td>
                                    <td>
                                        <h6 class="font-weight-bolder">{{convertCurrencyToLocal(orderDetails.discount)}}</h6>
                                    </td>
                                </tr>
                                <tr v-if="orderDetails.partial">
                                    <td>
                                        <h6 class="font-weight-bolder">Balance</h6>
                                    </td>
                                    <td></td>
                                    <td>
                                        <h6 class="font-weight-bolder">{{convertCurrencyToLocal(orderDetails.balance)}}</h6>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h4 class="font-weight-bolder">Grand Total</h4>
                                    </td>
                                    <td></td>
                                    <td>
                                        <h4 class="font-weight-bolder">{{convertCurrencyToLocal(orderDetails.total_amount)}}</h4>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr/>
                </div>
            </div>
        </div>
        <b-modal ref="paidAmountmodal" hide-footer hide-title>
            <div class="container py-3">
                <!-- Cash Amount Input -->
                <div class="row align-items-center mb-3">
                    <div class="col-md-6">
                        <h5 class="text-primary mb-0">Cash Amount</h5>
                        <small class="text-muted">Amount of cash received from the customer</small>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control border-0 border-bottom" v-model="paidAmount" type="number" placeholder="Enter cash received" required />
                    </div>
                </div>
                <!-- Order Amount Display -->
                <div class="row align-items-center mb-3">
                    <div class="col-md-6">
                        <h5 class="text-primary mb-0">Order Amount</h5>
                        <small class="text-muted">Total amount of the order</small>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control border-0 border-bottom bg-light" :value="splitPaymentAmount" readonly />
                    </div>
                </div>
                <!-- Change to Give -->
                <div class="row align-items-center mb-4">
                    <div class="col-md-6">
                        <h5 class="text-primary mb-0">Change</h5>
                        <small class="text-muted">Amount to return to the customer</small>
                    </div>
                    <div class="col-md-6">
                        <div v-if="changeToCustomer > 0">
                            <button class="btn btn-outline-success btn-block">
                {{ convertCurrencyToLocal(changeToCustomer) }}
              </button>
                        </div>
                        <div v-else>
                            <span class="text-muted">No change to return</span>
                        </div>
                    </div>
                </div>
                <!-- Confirm Button -->
                <div class="text-right">
                    <button class="btn btn-primary" @click="cashCheckout()">Confirm Payment</button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="customer-mpesa-phone-request" hide-footer hide-title>
            <div class="d-block text-center">
                <h2>Enter customer number that will be used to pay</h2>
                <small>Order amount {{ convertCurrencyToLocal(orderDetails.total_amount) }}</small>
                <div class="container py-3">
                    <form @submit.prevent="sendMpesaStkPush">
                        <vue-tel-input v-model="stkPhoneNumber"></vue-tel-input>
                        <button type="submit" class="btn btn-primary my-2 btn-block" :href="checkOutDoneLink">Send Mpesa Request </button>
                    </form>
                </div>
            </div>
        </b-modal>
        <b-modal id="modal-5" ref="choosePaymentMethodModal" hide-footer>
            <h5 class="text-center pt-2">Balance - {{ convertCurrencyToLocal(orderDetails.balance) }}</h5>
            <hr/>
            <select v-if="paymentGateways" class="custom-select" v-model="splitPaymentSelect">
                     <option value="null">--Select Payment--</option>
                     <option v-if="payment.enabled" v-for="payment in paymentGateways" :value="payment">{{ payment.payment_method }}</option>
                    </select>
            <div v-else class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <small class="text-danger">{{ splitPaymentSelectError }}</small>
            <hr/>
            <div v-if="splitPaymentAmount !==false && splitPaymentAmount !== null">
                <input v-model="splitPaymentAmount" class="form-control" placeholder="Enter amount" />
                <p><small>To split Payment you can change amount (Applies to deposits)</small></p>
                <div v-if="splitPaymentAmount !==false && splitPaymentAmount !=='' && splitPaymentAmount !== null && paymentGateways.length > 0 " class="py-3 text-center">
                    <a v-if="splitPaymentBtnTxt==='Process the balance'" class="btn btn-outline-secondary btn-sm mx-1" :href="checkOutDoneLink">Continue To Print Reciept</a>
                    <a :class="['btn', 'btn-primary','btn-sm', 'mx-1', 'btn-block', { 'disabled': isSubmitting }]" @click="processSplitPaymentModal()">{{ splitPaymentBtnTxt }}</a>
                </div>
            </div>
            <div v-else class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </b-modal>
        <b-modal ref="process_mpesa" id="modal-center" hide-header hide-footer>
            <div class="text-center pt-3">
                <div v-html="statusholder">
                </div>
            </div>
        </b-modal>
        <b-modal id="new_customers_modal" ref="new_customers_modal" hide-footer static>
            <div class="Text-centre">
                <h2 class="font-weight-bold text-dark ">Add Customer</h2>
            </div>
            <div class="container py-3">
                <!-- Actual search box -->
                <form @submit.prevent="newCustomerInfo">
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="newCustomerForm.f_name" name="f_name" type="text" placeholder="First Name" />
                            <!--<small class="text-danger">{{ errors.first('f_name') }}</small>-->
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="newCustomerForm.l_name" name="l_name" type="text" placeholder="Last Name" />
                            <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
                        </div>
                    </div>
                    <div class="form-group py-1">
                        <input class="form-control border-bottom" name="c_email" v-model="newCustomerForm.c_email" type="email" placeholder="Email" />
                    </div>
                    <div class="form-group">
                        <input class="form-control border-bottom" v-model="newCustomerForm.phone_no" name="phone_no" type="text" placeholder="Phone Number" />
                    </div>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="newCustomerForm.h_no" name="h_no" type="text" placeholder="House Number" />
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="newCustomerForm.apartment" name="apartment" type="text" placeholder="Apartment" />
                        </div>
                    </div>
                    <div class="form-row py-1">
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="newCustomerForm.street" name="street" type="text" placeholder="Street" />
                        </div>
                        <div class="col-6">
                            <input class="form-control border-bottom" v-model="newCustomerForm.town" name="town" type="text" placeholder="Town" />
                        </div>
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-primary btn-block">Add Customer</button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal ref="selected_bnpl_customer_modal" hide-footer>
            <div>
                <p>Type to start searching customer</p>
                <div class="input-group">
                    <input v-model=" customerData.searchTerm" type="text" class="form-control" placeholder="Search by name, email, or phone number">
                </div>
                <ul class="my-3" v-if="customerData.allcustomers.length > 0">
                    <li v-for="customer in customerData.allcustomers" :key="customer.id" @click="selectBNPLCustomer(customer)">
                        {{ customer.full_name }} - {{ customer.phone }}
                        <hr class="m-0 my-1" />
                    </li>
                </ul>
            </div>
        </b-modal>
        <b-modal ref="bnpl_modal" hide-footer>
            <div class="text-center">
                <h5>Buy Now Pay Later Details</h5>
            </div>
            <small v-if="bnplForm.customerError !==''" class="text-danger">{{ bnplForm.customerError }}</small>
            <form @submit.prevent="processBNPLPayment()">
                <div class="form-group">
                    <label>Customer Details</label>
                    <input v-if="bnplForm.orderDetails.customer !==null" type="text" class="form-control" v-model="bnplForm.orderDetails.customer.full_name" placeholder="Customer Name/Phone/Email" readonly/>
                    <p v-if="bnplForm.orderDetails.customer ===null"><a href="#" @click="selectedBNPLCustomerModal">Select Customer</a></p>
                    <p v-if="bnplForm.orderDetails.customer !==null"><a href="#" @click="selectedBNPLCustomerModal">Select To Change Customer</a></p>
                </div>
                <div class="form-group">
                    <label>Total Amount</label>
                    <input type="integer" class="form-control" v-model="bnplForm.orderDetails.balance" readonly/>
                </div>
                <div class="form-group">
                    <label>Deposit</label>
                    <input type="integer" class="form-control" v-model="bnplForm.depositAmount" />
                </div>
                <div class="form-group">
                    <label>Due Date</label>
                    <b-form-datepicker v-model="bnplForm.dueDate" :min="bnplForm.minimumDate" class="form-control" required></b-form-datepicker>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-outline-primary btn-block">Process BNPL</button>
                </div>
            </form>
        </b-modal>
        <b-modal ref="errorModal" hide-footer>
            <div class="container text-center">
                <h6 class="text-danger">
                    There was an error
                </h6>
                <hr/>
                <p>{{ errorModalMessage }}</p>
                <a class="btn btn-outline-primary my-2 px-1" href="/makesale">Make a new sale</a>
            </div>
        </b-modal>
         <b-modal id="create-kitchen-note-modal" hide-footer hid-header>
                <h5 class="py-2">Add a note to kitchen</h5>
                <form @submit.prevent="sendOrderToKitchen">
                    <div class="form-group">

                    <textarea class="form-control" id="exampleFormControlTextarea1" v-model="noteForm.noteText" rows="3" placeholder="Enter your note..."></textarea>
                </div>

                    <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="noteForm.addToReceipt" class="custom-control-input" id="customSwitch1">
                    <label class="custom-control-label" for="customSwitch1">Add to Receipt</label>
                    </div>


                    <div class="d-inline  ">
                           <div class="d-flex" v-if="companySettings.has_kds">


                        <button  class="btn btn-primary rounded flex-grow-1 mx-1 ">Save & Send to Kitchen</button>
                          <a :href='"/print_invoice/" + orderDetails.id + "?order-receipt=true"'  class="btn btn-outline-primary rounded flex-grow-1 ">Skip and Print Order</a>
                    </div>

                    </div>
                </form>

                </b-modal>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: "checkout",
        props: [
            'orderid',
        ],
        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth() - 2)
            minDate.setDate(15)
            return {
                orderDetails: {},
                errorModalMessage: '',
                storeSettings: {},
                splitPaymentSelect: null,
                splitPaymentSelectError: '',
                splitPaymentAmount: false,
                paymentGateways: '',
                disabledPaymentGateways: 0,
                paidAmount: 0,
                orderamount: '',
                changeToCustomer: 0,
                isSubmitting: false,
                companySettings: {},
                customerData: {
                    searchTerm: '',
                    allcustomers: [],
                    filteredCustomers: []
                },
                 noteForm: {
                    addToReceipt: false,
                    noteText: '',
                },
                searchTimeout: '',
                bnplForm: {
                    dueDate: '',
                    depositAmount: 0.00,
                    interest: false,
                    minimumDate: minDate,
                    paymentId: '',
                    customerError: '',
                    orderDetails: {
                        customer: {
                            full_name: ''
                        }
                    }
                },
                newCustomerForm: {
                    town: '',
                    street: '',
                    apartment: '',
                    h_no: '',
                    phone_no: '',
                    c_email: '',
                    l_name: '',
                    f_name: '',
                },
                checkOutDoneLink: '',
                splitPaymentBtnTxt: 'Process Payment',
                stkPhoneNumber: '',
                selectedPaymentMethod: '',
                checkmpesaresponsepoll: null,
                statusholder: '<div><h4>Validating payment</h4></div><div class="spinner-border mt-5 text-primary" role="status">\n' +
                    '  <span class="sr-only">Loading...</span>\n' +
                    '</div>' +
                    '<p class="py-2" >Please ask customer to check their phone and input MPesa PIN  </p><p class="py-2" >  Awaiting confirmation.... </p>',
            }
        },
        computed: {
            ...mapGetters(['userDetails'])
        },
        methods: {
            async sendOrderToKitchen() {
                try {
                    const path = window.location.pathname;
                    const id = path.split('/').pop(); // Gets the last part
                    const res = await axios.post(`/api/send-to-kitchen/${id}`,{...this.noteForm});
                    if(res.status === 200)
                    {
                        window.location.href = '/orders'
                    }


                } catch (err) {
                    console.error("Failed to fetch orders:", err);
                }
            },
            hasPermission(permissionName) {
                return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
            selectedBNPLCustomerModal() {
                this.$refs.selected_bnpl_customer_modal.show()
            },
            async processBNPLPayment() {
                if (this.bnplForm.orderDetails.customer !== null) {
                    await axios.post('/api/pay-via-bnpl', { ...this.bnplForm
                    }).then(results => {
                        if (results.status === 200) {
                            this.checkOutDoneLink = this.storeSettings.skip_checkout_done ? '/print_invoice/' + results.data.final_order_id : '/paid/view-order-details/' + results.data.final_order_id
                            this.$store.commit('resetStore')
                            window.location.replace(this.checkOutDoneLink)
                        }
                    }).catch(err => {
                        this.$refs.bnpl_modal.hide()
                        this.$toasts.push({
                            type: 'error',
                            message: "This order already has BNPL payment, you can set it only once !"
                        })
                    })
                } else {
                    this.bnplForm.customerError = 'You need to select a customer'
                }
            },
            // searchCustomers() {
            //         const searchTerm = this.customerData.searchTerm.toLowerCase();
            //         this.customerData.filteredCustomers = this.customerData.allcustomers.filter(customer =>
            //         (customer.full_name && customer.full_name.toLowerCase().includes(searchTerm)) ||
            //         (customer.email && customer.email.toLowerCase().includes(searchTerm)) ||
            //         (customer.phone && customer.phone.includes(searchTerm))
            //         );
            // },
            selectBNPLCustomer(customer) {
                this.bnplForm.orderDetails.customer = customer
                this.$refs.selected_bnpl_customer_modal.hide()
            },
            async newCustomerInfo() {
                await axios.post('/api/newcustomer', {
                        town: this.newCustomerForm.town,
                        street: this.newCustomerForm.street,
                        apartment: this.newCustomerForm.apartment,
                        h_no: this.newCustomerForm.h_no,
                        phone_no: this.newCustomerForm.phone_no,
                        c_email: this.newCustomerForm.c_email,
                        l_name: this.newCustomerForm.l_name,
                        f_name: this.newCustomerForm.f_name
                    })
                    .then(result => {
                        if (result.status === 200) {
                            setTimeout(() => {
                                this.successMessage = "<hr/><p><span class='text-success'><i class=\"bi bi-check-circle\"></i>  Customer added successfully</span></p>"
                            }, 3000)
                            this.bnplForm.orderDetails.customer = result.data.customer
                        }
                    });
            },
            async getData() {
                await axios.get('/api/order-details-minimal', {
                    params: {
                        orderId: this.orderid
                    }
                }).then(results => {
                    this.orderDetails = results.data;
                })
            },
            getUserCompanySettings() {
                this.companySettings = this.userDetails.company.companysettings
            },
            choosePaymentMethodModalShow() {
                if ((parseInt(this.orderDetails.balance) >= 0 || this.orderDetails.total_amount === this.orderDetails.discount) && this.paymentGateways) {
                    this.splitPaymentAmount = this.orderDetails.balance
                    this.$refs.choosePaymentMethodModal.show()
                } else {
                    console.log('--balance', this.orderDetails.balance)
                }
            },
            orderGoBack() {
                const urlParams = new URLSearchParams(window.location.search);
                const source = urlParams.get('source');
                if (source) {
                    window.location.href = source;
                } else {
                    this.discardOrder(this.orderDetails)
                }
            },
            async processSplitPaymentModal() {
               this.$store.commit('resetStore')

                if (this.splitPaymentSelect === null) {
                    this.splitPaymentSelectError = 'Select atleast one mode of payment'
                } else {
                    if (this.splitPaymentAmount < 0 || this.splitPaymentAmount > this.orderDetails.balance) {
                        this.splitPaymentSelectError = "Please check on the amount, the balance for this order is " + this.$root.convertCurrencyToLocal(this.orderDetails.balance)
                    } else {
                        this.splitPaymentBtnTxt = "Processing Payment ..."
                        this.splitPaymentSelectError = ""
                        this.$refs.choosePaymentMethodModal.hide()
                        this.isSubmitting = true;
                        this.checkPaymentGateway(this.splitPaymentSelect, this.orderDetails, this.splitPaymentAmount)
                    }
                }
            },
            async processSplitPayment() {
                // Check if all required fields are provided
                if (!this.splitPaymentSelect.id || !this.splitPaymentAmount || !this.orderDetails.id) {
                    this.errorModalMessage = 'Please fill in all required fields: Payment Method, Amount, and Order ID.';
                    this.$refs.errorModal.show();
                    this.isSubmitting = false;
                    return; // Exit if any field is missing
                }
                // Proceed with the API request if all required fields are present
                await axios.post('/api/split-payment', {
                    paymentMethod: this.splitPaymentSelect.id,
                    amount: this.splitPaymentAmount,
                    orderId: this.orderDetails.id,
                }).then(results => {
                    if (results.status === 200) {
                        this.checkOutDoneLink = this.storeSettings.skip_checkout_done ? '/print_invoice/' + results.data.id : '/paid/view-order-details/' + results.data.id
                        this.orderDetails = results.data;
                        if (this.orderDetails.balance === 0) {
                            window.location.replace(this.checkOutDoneLink);
                        } else {
                            this.splitPaymentBtnTxt = "Process the balance";
                            this.splitPaymentSelect = 'null';
                            this.splitPaymentAmount = this.orderDetails.balance;
                            this.isSubmitting = false;
                            this.choosePaymentMethodModalShow();
                        }
                    }
                }).catch(error => {
                    // Handle errors gracefully
                    this.$root.disableInterceptor();
                    this.errorModalMessage = error.response.data.message || 'Error processing payment';
                    this.$refs.errorModal.show();
                    this.isSubmitting = false;
                    this.splitPaymentBtnTxt = "Retry Payment";
                });
            },
            skipBalanceandPrintReciept() {
                window.location.replace(checkOutDoneLink)
            },
            async getStoreSettings() {
                await axios.get('/api/settings').then(results => {
                    this.storeSettings = results.data
                })
            },
            async getPaymentGateways() {
                await axios.get('/api/payments').then(results => {
                    this.paymentGateways = results.data
                    $.each(this.paymentGateways, (index, payment) => {
                        if (!payment.enabled) {
                            this.disabledPaymentGateways++
                        }
                    })
                })
            },
            async processFullPayment() {
                await axios.post('/api/full-payment', {
                    paymentMethod: this.splitPaymentSelect.id,
                    amount: this.splitPaymentAmount,
                    orderId: this.orderDetails.id,
                }).then(results => {
                    if (results.status === 200) {
                        this.checkOutDoneLink = this.storeSettings.skip_checkout_done ? '/print_invoice/' + results.data.id : '/paid/view-order-details/' + results.data.id
                        this.orderDetails = results.data
                        if (this.orderDetails.balance === 0) {
                            window.location.replace(this.checkOutDoneLink)
                        }
                    }
                }).catch(error => {
                    this.$root.disableInterceptor()
                    this.errorModalMessage = error.response.data.message
                    this.$refs.errorModal.show();
                    this.isSubmitting = false
                    this.splitPaymentBtnTxt = "Retry Payment"
                })
            },
            cashCheckout() {
                (this.splitPaymentAmount === this.orderDetails.total_amount) ? this.processFullPayment(): this.processSplitPayment()
                this.$refs['paidAmountmodal'].hide();
            },
            checkPaymentGateway(payment, orderDetails, amountToPay) {
                const link = this.storeSettings.skip_checkout_done ? '/print_invoice/' + orderDetails.id : '/paid/view-order-details/' + orderDetails.id
                this.checkOutDoneLink = link;
                const paymentMethod = payment.payment_method
                this.orderamount = orderDetails.total_amount;
                if (paymentMethod.toLowerCase() === 'cash') {
                    // openmodal
                    this.$refs['paidAmountmodal'].show();
                    this.$store.commit('resetStore')
                } else if (paymentMethod.toLowerCase() === 'm-pesa') {
                    if (this.storeSettings.use_dukakit_paybill) {
                        this.$refs['customer-mpesa-phone-request'].show()
                        this.selectedPaymentMethod = paymentMethod
                    } else {
                        (amountToPay === orderDetails.total_amount) ? this.processFullPayment(): this.processSplitPayment()
                       this.$store.commit('resetStore')
                    }
                } else if (paymentMethod.toLowerCase() === 'buy now pay later') {
                    this.bnplForm.paymentId = payment.id
                    this.bnplForm.orderDetails = this.orderDetails
                    this.$refs.bnpl_modal.show()
                } else {
                    (amountToPay === orderDetails.total_amount) ? this.processFullPayment(): this.processSplitPayment()
                    this.$store.commit('resetStore')
                }
            },
            sendMpesaStkPush() {
                this.orderDetails.stkPhoneNumber = this.stkPhoneNumber
                this.processPayment(this.selectedPaymentMethod, this.orderDetails)
                this.$refs['customer-mpesa-phone-request'].hide()
            },
            backToCart() {
                window.location.href = '/makesale';
            },
            async discardOrder(orderDetails) {
                await axios.delete('/api/delete-order/' + orderDetails.id).then(results => {
                    if (results.status === 200) {
                        this.$store.commit('resetStore')
                        window.location.replace('/makesale');
                    }
                }).catch({})
            },
            async processPayment(paymentMethod, orderData) {
                await axios.post('/api/process-order-payment', {
                    method: paymentMethod,
                    orderData: orderData
                }).then(results => {
                    if (results.data.message === "accepted for processing") {
                        this.$refs['process_mpesa'].show();
                        this.checkmpesaresponsepoll = setInterval(async() => {
                            await axios.get('/api/validate-transaction', {
                                params: {
                                    orderId: this.orderDetails.id
                                }
                            }).then(checkerresults => {
                                if (checkerresults.data.message === 1) {
                                    this.statusholder = "<div class=\"success-checkmark\">\n" +
                                        "  <div class=\"check-icon\">\n" +
                                        "    <span class=\"icon-line line-tip\"></span>\n" +
                                        "    <span class=\"icon-line line-long\"></span>\n" +
                                        "    <div class=\"icon-circle\"></div>\n" +
                                        "    <div class=\"icon-fix\"></div>\n" +
                                        "  </div>\n" +
                                        "</div> <div class='text-center'> <h6 class='text-smanel-gray-lvl3'>Your payment has been received and your account has been credited</h6> </div>"
                                    setInterval(() => {
                                        // clear polling ID
                                        clearInterval(this.checkmpesaresponsepoll);
                                        // CLOSE MODAL
                                        this.$refs['process_mpesa'].hide();
                                        window.location.replace(this.checkOutLink)
                                        this.$store.commit('resetStore')
                                    }, 3000)
                                }
                                if (checkerresults.data.message === 0) {
                                    this.statusholder = "<div class=\"container text-center\">\n" +
                                        "<h5 class=\"text-danger text-smanel-50\">\n" +
                                        "<i class=\"bi bi-x-circle\"></i>\n" +
                                        "</h5>\n" +
                                        "<p>There was an issue with payment (" + checkerresults.data.description + ") </p>\n" +
                                        "\n" +
                                        "<a class=\"btn btn-primary\" href=\"//checkout/" + this.orderDetails.order + "\">Retry Payment</a>\n" +
                                        "\n" +
                                        "</div>"
                                }
                            }).catch()
                        }, 10000)
                    }
                }).catch(errors => {})
            },
            async getCustomers() {
                await axios.get(`/api/allcustomers?search=${this.customerData.searchTerm}`)
                    .then(result => {
                        if (result.status === 200) {
                            this.customerData.allcustomers = result.data.data;
                        }
                    });
            },
        },
        mounted() {
            this.getData();
            this.getPaymentGateways();
            this.getStoreSettings();
            this.getCustomers()
            this.getUserCompanySettings()
        },
        watch: {
            paidAmount(before, after) {
                this.changeToCustomer = this.paidAmount - this.splitPaymentAmount;
            },
            splitPaymentAmount(before, after) {
            },
            splitPaymentSelect(before, after) {
                const btnText = "Process Payment"
                this.splitPaymentBtnTxt = btnText + " - " + this.splitPaymentSelect.payment_method
            },
            'customerData.searchTerm': function() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.getCustomers();
                }, 500); // Debounce delay (500ms)
            }
        }
    }
</script>

<style scoped>

</style>
